import React, { useContext, useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";

const OtpVerification = () => {
  const { apiURL } = useContext(ConfigContext);
  const [otp, setotp] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();


  const handleotpChange = (event) => {
    setotp(event.target.value);
  };
  useEffect(() => {
    setErrorMessage("");
  }, [otp]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post(`${apiURL}User/OtpVerification?reset_pwd_otp=${otp}`);
      // setIsLoading(false);
      const data = response.data;
      if (data.success === true) {
        setTimeout(() => {
          navigate(`/ConfirmPassword/${data.data.employee_id}`);
        }, 1000);
        return;
      } else {
        setErrorMessage(data.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(`error`, error);
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="auth-page-wrapper pt-5 ">

        <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
          <div className="bg-overlay "></div>

          <div className="shape">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 1440 120"
            >
              <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
            </svg>
          </div>
        </div>
      </div>

      <div className="auth-page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mt-sm-5 mb-4 text-white">
                <div className="d-inline-block auth-logo">
                </div>
                <p className="mt-3 fs-15 fw-bolder"></p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-4">
                <div className="card-body p-4">
                  <div className="mb-4">
                    <div className="avatar-lg mx-auto">
                      <div className="avatar-title bg-light text-primary display-5 rounded-circle">
                        <i className="ri-mail-line" />
                      </div>
                    </div>
                  </div>
                  <div className="p-2 mt-4">
                    <div className="text-muted text-center mb-4 mx-lg-3">
                      {errorMessage ? (
                        <h4 className="text-danger">{errorMessage}</h4>
                      ) : (
                        <h4>Verify Your Email</h4>
                      )}
                      <p>Please enter the 5 digit code sent to Email</p>
                    </div>
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="mb-3">
                            <input type="number" onChange={handleotpChange} value={otp} className="form-control form-control-lg bg-light border-light text-center" id="otp" />
                          </div>
                        </div>
                      </div>
                      <div className="mt-3">
                        <button type="submit" disabled={!otp || isLoading} className="btn btn-secondary w-100">Confirm</button>
                      </div>
                    </form>
                  </div>
                </div>
                {/* end card body */}
              </div>
              {/* end card */}
              <div className="mt-4 text-center">
                <p className="mb-0">Didn't receive a code ? <NavLink to={'/ForgotPassword'} className="fw-semibold text-primary text-decoration-underline">Resend</NavLink> </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default withRouter(OtpVerification);